import { css } from '@emotion/react';
import styled from '@emotion/styled';

import type { TMessageStyleConfig } from './message.types';

const MessageWrapper = styled.section`
	padding: 3px 9px;

	@media ${({ theme }) => theme.medias.desktop} {
		padding: 0 9px;
	}
`;

const MessageBalloon = css`
	border-radius: 16px;
	padding: 12px 16px;
	word-wrap: break-word;
`;

const flexStart = 'flex-start';

export const Message = styled(MessageWrapper)<Pick<TMessageStyleConfig, 'itsMyMessage'>>`
	width: 100%;
	height: auto;
	flex-direction: column;
	display: flex;

	& > a {
		align-self: ${({ itsMyMessage }) => (itsMyMessage ? 'flex-end' : flexStart)};
	}
`;

export const Balloon = styled.div<TMessageStyleConfig>`
	display: flex;
	flex-direction: column;

	justify-content: ${({ itsMyMessage }) => (itsMyMessage ? 'flex-end' : flexStart)};
	align-items: ${({ itsMyMessage }) => (itsMyMessage ? 'flex-end' : flexStart)};

	& > span:first-of-type {
		${MessageBalloon}

		background: ${({ theme, itsMyMessage, hasVehicleInfo }) => {
			if (hasVehicleInfo) return theme.colors.gray2;
			if (itsMyMessage) return theme.colors.gray5;
			return '#fff';
		}};
		border-radius: ${({ itsMyMessage }) => (itsMyMessage ? '16px 0px 16px 16px' : '0 16px 16px 16px')};
		${({ itsMyMessage }) => (itsMyMessage ? '' : 'box-shadow: 0 0 1px rgba(0, 0, 0, 0.5);')};
		font-size: 12px;
		line-height: 150%;
		color: ${({ theme, hasVehicleInfo }) => (hasVehicleInfo ? '#fff' : theme.colors.gray1)};
		max-width: 320px;
		min-width: auto;
		display: inline-block;
		position: relative;
		z-index: 1;

		& > i {
			font-style: italic;
			color: #ccc;
		}

		& > input {
			opacity: 0;
			position: absolute;
			z-index: -1;
		}
	}
`;

export const WrapperBalloonAndOption = styled.div<TMessageStyleConfig>`
	display: flex;
	align-self: ${({ itsMyMessage }) => (itsMyMessage ? 'flex-end' : flexStart)};
	${({ itsMyMessage }) => (itsMyMessage ? '' : 'flex-direction: row-reverse')};
	${({ hasVehicleInfo }) => hasVehicleInfo && 'margin-top: 4px;'}

	&:hover > .wrapper__option {
		opacity: 1;
		width: 18px;
	}

	time {
		padding: 4px;
		${({ itsMyMessage }) => (itsMyMessage ? '' : 'width: 100%;')};
	}
`;

export const Option = styled.span`
	width: 0;
	transition: all 0.2s linear;
	opacity: 0;
	z-index: 4;
	display: flex;
	justify-content: center;
	cursor: pointer;
	position: relative;
`;

export const Status = styled.span``;

export const Info = styled.span<Pick<TMessageStyleConfig, 'itsMyMessage'>>`
	display: flex;
	justify-content: flex-end;
	align-items: center;
	height: 24px;

	& > time {
		color: ${({ theme }) => theme.colors.gray3};
		font-size: 10px;
	}
`;

export const EmptyTag = styled.div`
	overflow-y: scroll;
`;
